import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';
import SearchIcon from '../../../Icon/SearchIcon';

interface InputSearchProps {
	placeholder?: string;
	input?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	readonly?: boolean;
	value?: string;
	type?: string;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const InputSearch = forwardRef<HTMLInputElement, InputSearchProps>(({ placeholder, input, readonly, value, type = 'text', onBlur }, ref) => {
	const { t } = useTranslation();

	return (
		<S.SearchInputBox>
			<S.IconWrapper>
				<SearchIcon />
			</S.IconWrapper>
			<S.SearchInput
				ref={ref}
				type={type}
				placeholder={placeholder ? t(placeholder) : undefined}
				onChange={input}
				readOnly={readonly}
				value={value}
				onBlur={onBlur}
			/>
		</S.SearchInputBox>
	);
});

InputSearch.displayName = 'InputSearch';

export default InputSearch;
